import AddIcon from "@mui/icons-material/Add";
import DownloadIcon from "@mui/icons-material/Download";
import LoopIcon from "@mui/icons-material/Loop";
import {
  Button,
  CircularProgress,
  IconButton,
  Paper,
  Skeleton,
  useMediaQuery,
} from "@mui/material";
import React, {
  Fragment,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Search from "../../../components/inputs/search";
import PageTitle from "../../../components/pageTitle";
import { resetAllSummeryData } from "../../../redux/actoin";
import { API } from "../../../scripts/api";
import axiosInstance from "../../../scripts/axiosInspector";
import CustomerCart from "./cart";
import CustomerData from "./data";
const Customer = () => {
  const [page, setPage] = useState(1);
  const [render, setRender] = useState(1);
  const navigate = useNavigate();
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;
  const CurrentCompany = useSelector((state) => state.CurrentCompany);
  const { company } = CurrentCompany;
  const [loadingCsv, setLoadingCsv] = useState(false);
  const [loadingRemove, setLoadingRemove] = useState(false);
  const [comment, setComment] = useState("");
  const [removeConfirm, setRemoveConfirm] = useState(false);
  const AllUsers = useSelector((state) => state.AllUsers);
  const dispatch = useDispatch();
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [loadedSearch, setloadedSearch] = useState(false);

  const [allDataC, setAllDataC] = useState([]);
  const [searchData, setSearchData] = useState("");
  const isMd = useMediaQuery("(min-width:756px)");

  const [allData, setAllData] = useState([]);
  useMemo(() => {
    if (AllUsers.users?.page) setPage(AllUsers.users?.page);
  }, []);
  const { hasMore, loading, customers, CurrentPage } = CustomerData(
    page,
    render
  );
  const observer = useRef();
  const lastInvoiceElement = useCallback(
    (node) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          setPage((page) => page + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [loading, hasMore, CurrentPage]
  );
  useEffect(() => {
    setAllData(customers);
    setAllDataC(customers);
  }, [customers]);
  const downloadExcel = () => {
    if (userInfo) {
      setLoadingCsv(true);
      axiosInstance
        .get(
          API.info.customer +
            `?guidStateRecNo=${
              company?.guidRecNo
            }&exportFormat=Excel&page=1&pageSize=${10}`,
          {
            headers: {
              Authorization: `Bearer ${userInfo?.token}`,
              "Cache-Control": "no-cache",
              Pragma: "no-cache",
              Expires: "0",
              "Accept-Language": "fa-IR",
              chHostName: process.env.REACT_APP_CHHOSTNAME,
            },
          }
        )
        .then((res) => {
          const base64Data = res.data.data.chExportFile; // Replace with actual base64 data
          DownloadDocument(1, "Excel", base64Data);
          setLoadingCsv(false);
        })
        .catch((err) => {
          setLoadingCsv(false);
        });
    }
  };
  const DownloadDocument = (title, exportFormat, base64Doc) => {
    let extension = ".txt";
    switch (exportFormat) {
      case "Excel":
        extension = ".xlsx";
        break;
      default:
        extension = ".txt";
        break;
    }
    var a = document.createElement("a");
    a.href = base64Doc;
    a.download =
      `خروجی خریداران${new Date().toLocaleDateString("fa-IR")}` + extension;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };
  const handleRemove = (item) => {
    setLoadingRemove(true);
    var temp = [...allData];
    axiosInstance
      .delete(
        API.info.customerSingle,

        {
          data: { chDeletedComment: comment, guidRecNo: item.guidRecNo },
          headers: {
            Authorization: `Bearer ${userInfo?.token}`,
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            Expires: "0",
            "Accept-Language": "fa-IR",
            chHostName: process.env.REACT_APP_CHHOSTNAME,
          },
        }
      )
      .then((res) => {
        dispatch(resetAllSummeryData());

        temp = temp.filter((it) => it.guidRecNo !== item.guidRecNo);
        setAllData(temp);
        setAllDataC(temp);
        setRemoveConfirm(false);
        setComment("");
        setLoadingRemove(false);
      })
      .catch((err) => {
        setLoadingRemove(false);
        /*      if (err.response.status === 401 || err.response.status === 403) {
          dispatch(handleLogOut());
        } */
      });
  };
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (searchData !== "") {
        setloadedSearch(true);
        setLoadingSearch(true);
        const params = new URLSearchParams();
        params.append("page", 1);
        company && params.append("guidStateRecNo", company?.guidRecNo);
        params.append("pageSize", 30);
        params.append("chSearchValue", searchData);

        axiosInstance
          .get(API.info.customer + `?${params}`, {
            headers: {
              Authorization: `Bearer ${userInfo?.token}`,
              "Cache-Control": "no-cache",
              Pragma: "no-cache",
              Expires: "0",
              "Accept-Language": "fa-IR",
              chHostName: process.env.REACT_APP_CHHOSTNAME,
            },
          })
          .then((res) => {
            setAllData(res?.data?.data?.rows);
            setLoadingSearch(false);
          })
          .catch((err) => {
            setLoadingSearch(false);
          });
      } else if (allDataC?.length > 0) {
        setloadedSearch(false);

        setAllData(allDataC);
        setLoadingSearch(false);
      } else {
        setloadedSearch(false);

        setLoadingSearch(false);
      }
    }, 1000);

    return () => clearTimeout(delayDebounceFn);
  }, [searchData]);
  return (
    <>
      <PageTitle
        broadCrumb={[
          {
            title: "فروش",
            path: "/sell",
          },
        ]}
        title={"خریداران"}
      />
      <Paper className="mx-3 my-5 border py-3 px-3 relative z-40" elevation={1}>
        <div className="flex md:flex-row flex-col-reverse justify-between md:items-center gap-x-4">
          <div></div>
          <div className="flex justify-end gap-5 sm:justify-end items-center">
            <Button
              onClick={downloadExcel}
              variant="contained"
              disabled={loadingCsv}
              sx={{ padding: "5px !important", minWidth: "40px !important" }}
            >
              {loadingCsv ? (
                <CircularProgress sx={{ mr: "2px" }} size={20} />
              ) : (
                <DownloadIcon />
              )}

              {/*   <span> خروجی اکسل </span> */}
            </Button>
            <Button
              onClick={() => navigate("/sell/customer/create")}
              variant="contained"
              sx={{ padding: "5px !important", minWidth: "40px !important" }}
            >
              <AddIcon />
            </Button>
          </div>
        </div>
      </Paper>
      <Paper
        className="mx-3 min-h-[60vh] mt-6 pb-32  mb-6 border relative z-40"
        elevation={1}
      >
        <div className="flex flex-col gap-4 sm:grid sm:grid-cols-2 lg:grid-cols-3 p-2">
          <>
            <div className=" lg:col-span-3 sm:col-span-2">
              <div className=" border-b flex pb-2 mb-2  items-end justify-between gap-4">
                <div className="flex gap-1 mt-5 items-center">
                  <span className="text-sm font-bold text-main">
                    تعداد موارد یافت شده :‌
                  </span>
                  <span className="text-sm font-bold text-main">
                    {allData?.length}
                  </span>
                </div>
                {isMd && (
                  <div className="mt-4">
                    <Search
                      search={searchData}
                      setSearch={(e) => {
                        /*                         if (e.target.value === "") setRender((r) => r + 1);
                         */ setSearchData(e.target.value);
                      }}
                    />
                  </div>
                )}
                <IconButton
                  onClick={() => {
                    setPage(1);
                    setRender((r) => r + 1);
                  }}
                  sx={{ padding: "0px !important" }}
                >
                  <LoopIcon
                    color="primary"
                    sx={{
                      color: (theme) =>
                        theme.palette.mode === "light"
                          ? ""
                          : "#fff  !important",
                    }}
                  />
                </IconButton>
              </div>
              {!isMd && (
                <div className="mt-4">
                  <Search
                    search={searchData}
                    setSearch={(e) => setSearchData(e.target.value)}
                  />
                </div>
              )}
            </div>
            {!loadingSearch ? (
              <>
                {allData?.map((item, index) => (
                  <Fragment key={item?.guidRecNo}>
                    {allData?.length === index + 1 && !loadedSearch ? (
                      <div ref={lastInvoiceElement}>
                        <CustomerCart
                          items={item}
                          removeHandle={() => handleRemove(item)}
                          setComment={setComment}
                          comment={comment}
                          loadingRemove={loadingRemove}
                          removeConfirm={removeConfirm}
                          setRemoveConfirm={(e) => setRemoveConfirm(e)}
                        />
                      </div>
                    ) : (
                      <div>
                        <CustomerCart
                          items={item}
                          removeHandle={() => handleRemove(item)}
                          setComment={setComment}
                          comment={comment}
                          loadingRemove={loadingRemove}
                          removeConfirm={removeConfirm}
                          setRemoveConfirm={(e) => setRemoveConfirm(e)}
                        />
                      </div>
                    )}
                  </Fragment>
                ))}
              </>
            ) : (
              <>
                {" "}
                <Skeleton
                  variant="rounded"
                  width={"100%"}
                  animation="wave"
                  height={140}
                />{" "}
                <Skeleton
                  variant="rounded"
                  width={"100%"}
                  animation="wave"
                  height={140}
                />{" "}
                <Skeleton
                  variant="rounded"
                  width={"100%"}
                  animation="wave"
                  height={140}
                />
              </>
            )}
          </>{" "}
          {loading && (
            <>
              <Skeleton
                variant="rounded"
                width={"100%"}
                animation="wave"
                height={140}
              />{" "}
              <Skeleton
                variant="rounded"
                width={"100%"}
                animation="wave"
                height={140}
              />{" "}
              <Skeleton
                variant="rounded"
                width={"100%"}
                animation="wave"
                height={140}
              />
            </>
          )}{" "}
        </div>
      </Paper>
    </>
  );
};

export default Customer;
